import { useHistory } from 'react-router';

export const useCoachingV2RouteHandler = () => {
  const history = useHistory();

  const handleCoachingV2Redirect = ({ pathname, search }: { pathname: string; search?: string }) => {
    history.push({ pathname, search });
  };

  return { handleCoachingV2Redirect };
};
